'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GroupSigning(blocked) {
  this.F4 = false;
  this.F4 = blocked;
}
export { $c_Lpresto_types$proto$GroupSigning as $c_Lpresto_types$proto$GroupSigning };
$p = $c_Lpresto_types$proto$GroupSigning.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GroupSigning;
/** @constructor */
function $h_Lpresto_types$proto$GroupSigning() {
}
export { $h_Lpresto_types$proto$GroupSigning as $h_Lpresto_types$proto$GroupSigning };
$h_Lpresto_types$proto$GroupSigning.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("GroupSigning"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.F4 ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 1);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$GroupSigning) && (this.F4 === x$0.F4)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "GroupSigning";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.F4;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$GroupSigning(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lj)));
}
export { $isArrayOf_Lpresto_types$proto$GroupSigning as $isArrayOf_Lpresto_types$proto$GroupSigning };
var $d_Lpresto_types$proto$GroupSigning = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GroupSigning, "presto.types$proto$GroupSigning", ({
  lj: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$GroupSigning as $d_Lpresto_types$proto$GroupSigning };
//# sourceMappingURL=presto.types$proto$-Group-Signing.js.map
